export class Constants {
    public static excludedProjectIds: string[] = [
        'JSwfB352vqfPcWTBrZSC',
        'y56IcxotS577bCcLkctm',
        '6twz0WFz7SsqYy34UGbQ',
        '5KV8tcNSYtXwSXmF6Af0',
        'kEldA6QN7567PhGiiK2d'
    ];
}